import { useEffect, Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster, toast } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Aides from "@/components/Aides";
import Reviews from "@/components/Reviews";
import Simulator from "@/components/Simulator";
import Process from "@/components/Process";
import Zones from "@/components/Zones";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";
import Admin from "@/components/Admin";
import Climatisation from "@/pages/Climatisation";
import { captureUtm } from "@/lib/utm";
import ChatWidget from "@/components/ChatWidget";
import { initPixel, trackContactOnPhoneClicks } from "@/lib/metaPixel";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-forest-deep p-8 text-center text-white">
          <p>Une erreur est survenue. Merci de recharger la page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

const Home = () => {
  useEffect(() => {
    initPixel();
  }, []);
  return (
  <>
    <Navbar />
    <main className="relative">
      <Hero />
      <Marquee />
      <Manifesto />
      <Aides />
      <Reviews />
      <Simulator />
      <Process />
      <Zones />
      <Faq />
      <Footer />
    </main>
    <ChatWidget product="pac" theme="dark" />
  </>
  );
};

function App() {
  useEffect(() => {
    captureUtm();
    const stopContactTracking = trackContactOnPhoneClicks();
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      stopContactTracking();
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-forest-deep font-sans text-white antialiased">
      <ErrorBoundary>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/climatisation" element={<Climatisation />} />
            <Route
              path="/admin"
              element={
                <>
                  <Navbar />
                  <Admin />
                </>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </ErrorBoundary>
      <div className="grain-overlay" aria-hidden="true" />
    </div>
  );
}

export default App;
